import AppBar from '@material-ui/core/AppBar';
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import Box from '@mui/material/Box';
import React, { useState } from "react";
import { connect } from "react-redux";
import CreateFinalreport from './createFinalReport';
import DeliverableData from './deliverableData';
import DeliverableFilter from './deliverableFilter';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "100%",
      flexGrow: 21,
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 40px 10px",
    },
    leftContentHeader: {
      width: "50%",
      float: "left",
    },
    rightContentHeader: {
      width: "50%",
      float: "right",
      textAlign: "right",
      paddingRight: "20px",
    },
    contentTable: {
      width: "100%",
      padding: "0px 0px 10px 0px",
      marginTop: "40px",
      minHeight: "300px",
    },
  })
);

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
  style: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}


interface Props {

}

const BookingPage: React.FC<Props> = ({

}) => {
  const classes = useStyles();
  const [bookingType, setBookingType] = useState<any>("homedx");
  const [value, setValue] = React.useState(0);
  const [newReport, setNewReport] = useState<string>("");
  const [onBoardingActionType,setOnboardingActionType]=useState<any>("Onboard Deliverable")
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    if(newValue===0){
      setOnboardingActionType("Onboard Deliverable")
    }
  };


  return (
    <>

      <div className={classes.root} style={{ marginTop: "3rem" }}>
        <AppBar position="static" >
          <Tabs variant="fullWidth" value={value} onChange={handleChange} aria-label="simple tabs example" style={{ justifyContent: "space-around" }}>
            <Tab label="Deliverable Data" {...a11yProps(0)} />
            <Tab label={onBoardingActionType} {...a11yProps(1)} />
          </Tabs>
        </AppBar>

        <TabPanel style={{ width: "100%" }} value={value} index={0} >
           <DeliverableFilter/>
         <DeliverableData setNewReport={setNewReport} setValue={setValue} setOnboardingActionType={setOnboardingActionType}/>
        </TabPanel>
        <TabPanel style={{ width: "100%" }} value={value} index={1}>
          <CreateFinalreport newReport={newReport} onBoardingActionType={onBoardingActionType}/>
        </TabPanel>

      </div>

    </>
  );
};
const mapStateToProps = (state: any) => ({

});
export default connect(mapStateToProps, {

})(BookingPage);

